var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:iphone-broken"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3327 9.33301C13.3327 11.847 13.3327 13.1043 12.5513 13.885C11.7707 14.6663 10.5133 14.6663 7.99935 14.6663C5.48535 14.6663 4.22802 14.6663 3.44735 13.885C2.66602 13.1043 2.66602 11.847 2.66602 9.33301V6.66634C2.66602 4.15234 2.66602 2.89501 3.44735 2.11434C4.22802 1.33301 5.48535 1.33301 7.99935 1.33301C10.5133 1.33301 11.7707 1.33301 12.5513 2.11434C13.3327 2.89501 13.3327 4.15234 13.3327 6.66634M9.99935 12.6663H5.99935",
    stroke: "#285430",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1647 1.58496L11.1087 1.66896C10.6047 2.42496 10.3527 2.80296 9.98465 3.03163C9.91136 3.07717 9.8352 3.11792 9.75665 3.15363C9.36198 3.33363 8.90798 3.33363 7.99932 3.33363C7.09065 3.33363 6.63598 3.33363 6.24198 3.15363C6.16343 3.11792 6.08728 3.07717 6.01398 3.03163C5.64598 2.80296 5.39398 2.42496 4.88998 1.66896L4.83398 1.58496",
    stroke: "#285430",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.83098a4e7a693f9485da3dd8f9913280.svg";
export { ForwardRef as ReactComponent };